// extracted by mini-css-extract-plugin
export default {"share":"Share_share__16coc"};